import { Action } from '@ngrx/store';
import { ItemModel } from '../../_models/item.model';
import { StoreModel } from '../../_models/store.model';
import { OrderModel } from '../../_models/order.model';


export enum ShoppingCartActionTypes {
  ItemAdd = '[Add Item] Action',
  ItemUpdate = '[Update Item] Action',
  ItemsList = '[List Items] Action',
  ItemRead = '[Read Item] Action',
  ItemRemove = '[Remove Item] Action',
  ItemClear = '[Clear Item] Action',
  ItemClearByStore = '[Clear Item by Store] Action',
  ItemsClearAll = '[Clear Item All] Action',
  ItemRequested = '[Request Item] Action',
  LoadShoppingCart = '[Load ShoppingCart] Action',
  OrderAddShoppingCart = '[Order Add ShoppingCart] Action',
  CartReplace = '[Replace Cart] Action',
  EmptyCart = '[Empty Cart] Action',
}

export class ItemAdd implements Action {
  readonly type = ShoppingCartActionTypes.ItemAdd;
  constructor(public payload: { item: ItemModel, store: StoreModel, order?: OrderModel }) { }
}
export class ItemsList implements Action {
  readonly type = ShoppingCartActionTypes.ItemsList;
}
export class ItemRead implements Action {
  readonly type = ShoppingCartActionTypes.ItemRead;
  constructor(public payload: { id: string }) { }
}
export class ItemRemove implements Action {
  readonly type = ShoppingCartActionTypes.ItemRemove;
  constructor(public payload: { indexItem: number, store: StoreModel }) { }
}

export class ItemClear implements Action {
  readonly type = ShoppingCartActionTypes.ItemClear;
  constructor(public payload: { indexItem: number, store: StoreModel }) { }
}
export class ItemsClearAll implements Action {
  readonly type = ShoppingCartActionTypes.ItemsClearAll;
}
export class ItemRequested implements Action {
  readonly type = ShoppingCartActionTypes.ItemRequested;
}

export class LoadShoppingCart implements Action {
  readonly type = ShoppingCartActionTypes.LoadShoppingCart;
}

export class ItemUpdate implements Action {
  readonly type = ShoppingCartActionTypes.ItemUpdate;
  constructor(public payload: { indexItem: number, item: ItemModel, store: StoreModel }) { }
}

export class ItemClearByStore implements Action {
  readonly type = ShoppingCartActionTypes.ItemClearByStore;
  constructor(public payload: { store_id: string }) { }
}

export class OrderAddShoppingCart implements Action {
  readonly type = ShoppingCartActionTypes.OrderAddShoppingCart;
  constructor(public payload: { store_id: string, order: OrderModel }) { }
}

export class CartReplace implements Action {
  readonly type = ShoppingCartActionTypes.CartReplace;
  constructor(public payload: { items: ItemModel[], store: StoreModel, order?: OrderModel, cardId: string}) { }
}

export class EmptyCart implements Action {
  readonly type = ShoppingCartActionTypes.EmptyCart;
}

export type ShoppingCartActions =
  ItemAdd |
  ItemsList |
  ItemRead |
  ItemRemove |
  ItemClear |
  ItemsClearAll |
  ItemRequested |
  LoadShoppingCart |
  ItemUpdate |
  ItemClearByStore |
  OrderAddShoppingCart |
  CartReplace |
  EmptyCart;
